type Auth0Config = {
  clientId: string
  discoveryUrl: string
  audience: string
  scopes: string[]
}

type Auth0StageKey = 'dev' | 'prod' | 'local'

/** Align with app.json scheme `pokerpower` and Android intent-filters (not applicationId-based schemes). */
const AUTH0_STAGE_CONFIG: Record<
  Auth0StageKey,
  Pick<Auth0Config, 'audience' | 'clientId' | 'discoveryUrl'>
> = {
  dev: {
    clientId: 'jLZ4DfgQD44FWSdnRnAmA68HrXQ6AUeO',
    discoveryUrl: 'https://auth.dev.pokerpower.com',
    audience: 'https://api.dev.ppwr.io'
  },
  prod: {
    clientId: 'AGXVbboBYhHykO3HZ4MvRGXnAvBpi1LR',
    discoveryUrl: 'https://login.auth.pokerpower.com',
    audience: 'https://api.ppwr.io'
  },
  local: {
    clientId: 'jLZ4DfgQD44FWSdnRnAmA68HrXQ6AUeO',
    discoveryUrl: 'https://auth.dev.pokerpower.com',
    audience: 'https://api.dev.ppwr.io'
  }
}

/**
 * Map EXPO_PUBLIC_STAGE to Auth0 tenant keys. Unknown values (e.g. `development`, `test`, unset) fall back to `dev`
 * so discovery/clientId are never undefined.
 */
export function resolveAuth0StageKey(): Auth0StageKey {
  const raw = (process.env.EXPO_PUBLIC_STAGE || '').trim().toLowerCase()
  if (raw === 'prod' || raw === 'production') return 'prod'
  if (raw === 'local') return 'local'
  return 'dev'
}

const stageKey = resolveAuth0StageKey()

const auth0ConfigBase = AUTH0_STAGE_CONFIG[stageKey]

export const auth0Config: Auth0Config = {
  ...auth0ConfigBase,
  scopes: ['name', 'email', 'openid', 'profile', 'offline_access', 'phone']
}
